import React, { useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import {useNotification} from 'config/Notification';

import { resetService, forgotPasswordVerifyService} from 'services/modules/idp/auth';

import {setErrors} from 'stores/modules/idp/authreducer';

import {Visibility, VisibilityOff} from '@mui/icons-material';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import {
  Button, 
  CircularProgress, 
  IconButton, 
  InputAdornment, 
  OutlinedInput
}from '@mui/material';

function ForgotPasswordVerification() {
  // State variables
  const [codeError, setCodeError] = useState('');
  const [formData, setFormData] = useState({ password: null, username: '', code: window.location.search.includes('code') ? new URLSearchParams(window.location.search).get('code') : '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [usernameError, setUsernameError] = useState('');
    
  // Redux selectors
  const getErrorsContainer = useSelector(state => state.auth.errors);
  
  // React Router
  const Navigate = useNavigate();

  // Redux dispatch
  const dispatch = useDispatch();  
  
  // Notification 
  const { openNotification } = useNotification();

  // Handles changes to the input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    switch(name) {
      case 'username':
        setUsernameError(value.trim() === '' ? 'Username is required' : '');
        break;
      case 'code':
        setCodeError(value.trim() === '' ? 'OTP is required' : '');
        break;
      case 'password':
        setPasswordError(value.trim() === '' ? 'Password is required' : '');
        break;
      default:
        break;
    }
  };
   
  // Handles form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username.trim()) {
      setUsernameError('Username is required');
      return;
    }
    if (!formData.code.trim()) {
      setCodeError('Verification code is required');
      return;
    }
    if (!formData.password.trim()) {
      setPasswordError('Password is required');
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await dispatch(forgotPasswordVerifyService(formData));
     
      if (response.type === 'auth/forgotPasswordVerify/rejected') {
        setErrorMessage(getErrorsContainer.data.message);
        openNotification(getErrorsContainer.data.message, 'error');
        setLoading(false);
      } 
      else if (response.type === 'auth/forgotPasswordVerify/fulfilled') {
        setLoading(false);
        openNotification('Password updated successfully', 'success');
        Navigate('/');
      }
      
    } 
    catch (error) {
      openNotification(errorMessage , "error")
    }
    setLoading(false);
  };
  
  // This method set the errors and redirect back to login
  const handleBack = () => {
    const empty = null;
    dispatch(setErrors(null));
    setErrorMessage(empty);
    Navigate('/');
  }
  
  // This method display errors if form validation is not satisfied
  const handleErrors = (e) => {
    const { name, value } = e.target;
    setShowPassword(false)
   
    switch(name) {
      case 'username':
        setUsernameError(value.trim() === '' ? 'Username is required' : '');
        break;
      case 'code':
        setCodeError(value.trim() === '' ? 'OTP is required' : '');
        break;
      case 'password':
        setPasswordError(value.trim() === '' ? 'Password is required' : '');
        break;
      default:
        break;
    }
  };
  
  // useEffect hook to handle reset
  useEffect(() => {
    dispatch(resetService());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='bg-Container'>
      <div className='col-xl-8 col-lg-8 col-md-8 col-sm-10 col-xs-12'>
        <div className="Card">
          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src="../assets/rhymtech_logo_2.png" alt="RhymLogo" className='Rhym-logo' />
            <div className="heading-container">
              <h4 className='headingtext-login'>RHYM Security Platform</h4>
            </div>
            <img src="../assets/6538623.5a47e6cc.jpg" alt="text" className="bg-logo" /> 
          </div>
          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <div className='Card-Container'>
              <div className='form-card'>
                <img src="../assets/loginuser.svg" alt="UserIcon" className="user-icon" />
                <h4 className="pageHeading">Reset Password</h4>
                <form onSubmit={handleSubmit}>
                  <OutlinedInput
                    className={usernameError ? 'err-label' : 'noerr-label'}
                    placeholder= {usernameError ? 'Username is required' : 'Username'}
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    onBlur={handleErrors}
                    required
                    endAdornment={usernameError && (
                      <InputAdornment position="end">
                        <ErrorOutlineIcon className='erroutline-icon' />
                      </InputAdornment>
                    )} 
                  />
                 
                  <OutlinedInput
                    className={codeError ? 'err-label' : 'noerr-label'}
                    placeholder= {codeError ? 'Verification code is required' :'Verification code' }
                    type="text"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                    onBlur={handleErrors}
                    required
                    endAdornment={codeError && (
                      <InputAdornment position="end">
                        <ErrorOutlineIcon className='erroutline-icon' />
                      </InputAdornment>
                    )}
                  />
                 
                  <OutlinedInput className={passwordError ? 'err-label' : 'noerr-label'} name="password" onChange={handleChange} 
                    placeholder={passwordError ? 'Password is required' :'Password' }
                    onBlur={handleErrors}
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton  onClick={() => setShowPassword(!showPassword) } edge="end" >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                          {passwordError && (
                            <ErrorOutlineIcon className='erroutline-icon'/>
                          )}
                        </IconButton>
                      </InputAdornment>
                    }                       
                  />
                 
                  <Button disabled={loading}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    className="submit-button"
                  >
                    {loading ? <CircularProgress size={24} /> : 'Update Password'}
                  </Button>
                  
                  <a onClick={handleBack} href  className='forgottext' >Back to login </a> 
                
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordVerification;
